<template>
  <div>
      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; font-size: 14px;" :flat='true'>
        <div v-if="!loading && (reg_count == 0)">
          <p v-if="can_reg && !wait_reg" style="color: red; font-size: 16px;"><b>Вы еще не зарегистрированы на Форум. Нажмите на кнопку ниже</b></p>
          <p v-if="!can_reg" style="color: red; font-size: 16px;"><b>Вы НЕ зарегистрированы на Форум. Регистрация докладчиком уже завершена</b></p>
          <p v-if="wait_reg" style="color: red; font-size: 16px;"><b>Регистрация на форум еще не открыта</b></p>
        </div>

        <div v-if="reg_count > 0">
          <!-- <p v-if="user_registrations[0].confirm_tour == 2" style="margin-bottom: 0px; font-size: 16px;"><b>Участник экскурсии в НИЦ "КИ":</b><b style="color: green;"> Да </b></p>
          <p v-else style="margin-bottom: 0px; font-size: 16px;"><b>Участник экскурсии в НИЦ "КИ":</b> <b style="color: red;">Нет </b></p> -->
                    
          <div v-if="reg_count < 3 && can_reg">
            <v-chip
              class="mr-2 ml-2 mt-2"
              dark
              outlined
              label
              style="margin-bottom:20px;"
              @click="add_reg_dialog = true"
              color="#ff810a">
              <v-icon left>mdi-plus</v-icon>
              Добавить выступление
            </v-chip>
          </div>
<!-- 
          <div v-if="(!currentSchoolStatus || currentSchoolStatus == 0) && listener_scholl">
            <p style="color: #ff6000; font-size: 16px; margin-bottom:0px; margin-top:0px; margin-right: 10px;">
              Так как вы планируете присутствовать на мероприятиях Школы «Современные подходы к созданию детекторных материалов», пожалуйста:
            </p>
            <v-btn
            style="margin-bottom:20px; max-width: 90% !important;"
              elevation="2"
              @click="scroll_to('current_school_status_ID')"
              color="#ff810a"
            > 
              заполните все недостающие персональные данные
            </v-btn> -->

            <!-- <div class="content-personal__header d-flex justify-space-between align-start">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="reg_id = reg_record.id, make_invite()"
                  color="#ff810a">
                  <v-icon left>mdi-check-decagram</v-icon>
                  Так как вы планируете присутствовать на мероприятиях Школы «Современные подходы к созданию детекторных материалов», пожалуйста, заполните все недостающие персональные данные
                </v-chip>
              </div> -->

          <!-- </div> -->

          <div v-for="reg_record in user_registrations" :key="reg_record.id">
            <v-card  class="main-container pa-3">
              
              <div v-if="reg_record.confirm_type > 0">
                <div class="d-flex">
                  <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"><b>Подтвержденный формат участия: </b> {{ reg_record.confirm_type == 1 ? 'Слушатель' : (reg_record.confirm_type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом') }}</p>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="red darken-1"
                        @click="reg_id = reg_record.id, cancel_reg_dialog = true">
                        mdi-close-circle-outline
                        </v-icon>
                    </template>
                    <span>отменить регистрацию</span>
                  </v-tooltip>
                </div>
                <div v-if="reg_record.confirm_type > 1">
                  <p style="font-size: 16px;  margin-right: 30px;"><b>Дата выступления: </b> {{ (reg_record.org_comment && reg_record.org_comment.length > 0) ? reg_record.org_comment : 'нет информации'}}</p>
                  <p style="margin-bottom: 0px; font-size: 16px;"><b>Секция: </b> {{ section_descr(reg_record.section_confirm_id) }}</p>
                  <p style="font-size: 16px;"><b>Название доклада: </b> {{ reg_record.comments && reg_record.comments.length > 0 ? reg_record.comments : 'Не указано при регистрации!'}}</p>
                </div>
              </div>
              <div v-else>
                <p style="color:orange; margin-bottom: 0px; margin-left: 10px; font-size: 20px;"> Заявка на участие принята </p>
                <p style="color:orange; margin-bottom: 0px; margin-left: 10px; font-size: 16px;"> ожидайте подтверждения участия модератором по e-mail</p>
                <div class="d-flex">
                  <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"><b>Формат участия: </b> {{ reg_record.type == 1 ? 'Слушатель' : (reg_record.type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом') }}</p>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="red darken-1"
                        @click="reg_id = reg_record.id, cancel_reg_dialog = true">
                        mdi-close-circle-outline
                        </v-icon>
                    </template>
                    <span>отменить регистрацию</span>
                  </v-tooltip>
                  <br>
                </div>
                <div v-if="reg_record.type > 1">
                  <p style="margin-bottom: 0px; font-size: 16px;" ><b>Секция: </b> {{ section_descr(reg_record.section_choice_id) }}</p>
                  <p style="font-size: 16px;"><b>Название доклада: </b> {{ reg_record.comments && reg_record.comments.length > 0 ? reg_record.comments : 'Не указано при регистрации!'}}</p>
                </div>
              </div>


              <div class="content-personal__header d-flex justify-space-between align-start" v-if="reg_record.is_confirm == false && reg_record.confirm_type > 0 && can_confirm">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="reg_id = reg_record.id, show_confirm_reg_dialog()"
                  color="#ff810a">
                  <v-icon left>mdi-check-decagram</v-icon>
                    Подтвердить участие в форуме
                </v-chip>
              </div>

              <!-- <div v-if="reg_record.need_tour == true">
                <p style="margin-bottom: 0px; font-size: 16px;  margin-right: 30px;"><b>Участие в экскурсии: </b> {{ reg_record.confirm_tour == 1 ? 'нет' : (reg_record.confirm_tour == 2 ? 'да' : '?') }}</p>

                <div class="content-personal__header d-flex justify-space-between align-start" v-if="reg_record.confirm_tour == 0 && false">
                  <v-chip
                    class="mr-2 ml-2"
                    dark
                    outlined
                    label
                    style="margin-bottom:20px;"
                    @click="reg_id = reg_record.id, show_confirm_tour_dialog(reg_record.id)"
                    color="#ff810a">
                    <v-icon left>mdi-check-decagram</v-icon>
                      Подтвердить участие в экскурсии
                  </v-chip>
                </div>
              </div> -->

              <!-- <div class="content-personal__header d-flex justify-space-between align-start" > -->
              <div class="content-personal__header d-flex justify-space-between align-start" v-if="(reg_record.confirm_type > 0 && reg_record.is_confirm == true)">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="reg_id = reg_record.id, make_invite()"
                  color="#ff810a">
                  <v-icon left>mdi-check-decagram</v-icon>
                  Скачать приглашение
                </v-chip>
              </div>
              <!-- <div class="content-personal__header d-flex justify-space-between align-start" v-if="reg_record.type > 1 && reg_record.is_confirm == false && reg_record.confirm_type == 0">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="reg_id = reg_record.id, make_invite()"
                  color="#ff810a">
                  <v-icon left>mdi-check-decagram</v-icon>
                  Скачать приглашение слушателя
                </v-chip>
              </div> -->
              <div class="content-personal__header d-flex justify-space-between align-start" v-if="(reg_record.confirm_type == 1 || (reg_record.confirm_type > 1 && reg_record.is_confirm == true)) && can_make_sert">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="reg_id = reg_record.id, make_sert()"
                  color="#ff810a">
                  <v-icon left>mdi-check-decagram</v-icon>
                  Скачать сертификат
                </v-chip>
              </div>

          
              <div class="date-interval d-flex">
                <p v-if="reg_record.is_confirm == true" style="color: green; font-size: 16px; margin-top:0px; margin-right: 10px;"><b>Вы подтвердили участие в Форуме</b></p>
              </div>

              <div class="content-personal__header d-flex justify-space-between align-start" v-if="can_upload_thesis && reg_record && (reg_record.confirm_type > 1 || (reg_record.confirm_type == 0 && reg_record.type > 1)) && !reg_record.file_id">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="upload_file_dialog = true, file = '', file_type = 'thesis_file', reg_id = reg_record.id"
                  color="#4dbee1">
                  <v-icon left>mdi-file-plus-outline</v-icon>
                    Загрузить тезисы *.doc
                </v-chip>
              </div>
              <div class="content-personal__header d-flex justify-space-between align-start" v-if="can_upload_thesis && reg_record && (reg_record.confirm_type > 1 || (reg_record.confirm_type == 0 && reg_record.type > 1)) && !reg_record.file_pdf_id">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="upload_file_dialog = true, file = '', file_type = 'thesis_pdf', reg_id = reg_record.id"
                  color="#4dbee1">
                  <v-icon left>mdi-file-plus-outline</v-icon>
                    Загрузить тезисы *.pdf
                </v-chip>
              </div>
              <div class="content-personal__header d-flex justify-space-between align-start" v-if="reg_record && (reg_record.confirm_type > 1 || (reg_record.confirm_type == 0 && reg_record.type > 1)) && !reg_record.exp_file_id">
                <v-chip
                  class="mr-2 ml-2"
                  dark
                  outlined
                  label
                  style="margin-bottom:20px;"
                  @click="upload_file_dialog = true, file = '', file_type = 'exp_file', reg_id = reg_record.id"
                  color="#4dbee1">
                  <v-icon left>mdi-file-plus-outline</v-icon>
                    Загрузить экспертное заключение
                </v-chip>
              </div>
              <div class="content-personal__header d-flex justify-space-between align-start" v-if="reg_record && (reg_record.file_id > 0 || reg_record.file_pdf_id > 0 || reg_record.exp_file_id > 0) && (reg_record.confirm_type > 1 || (reg_record.confirm_type == 0 && reg_record.type > 1))">
                <v-list subheader>
                  <v-list-item v-if="reg_record.file_id > 0">
                    <v-list-item-avatar>
                      <v-icon left>mdi-file</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-badge style="margin-top: 0px !important;" color="red lighten-2" :content="'Тезисы *.doc'" x-small inline>
                          <p style="margin-bottom: 0px;">{{ get_filename(reg_record.file) }}</p>
                        </v-badge>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn left @click="openFile(reg_record.file)" icon>
                        <v-icon color="grey lighten-1">mdi-download</v-icon>
                      </v-btn>
                    </v-list-item-action>
                    <v-list-item-action v-if="can_delete_thesis">
                      <v-btn left @click="deleteFile(reg_record.id, 'del_thesis_doc')" icon>
                        <v-icon color="grey lighten-1">mdi-delete-forever</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item v-if="reg_record.file_pdf_id > 0">
                    <v-list-item-avatar>
                      <v-icon left>mdi-file</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-badge style="margin-top: 0px !important;" color="red lighten-2" :content="'Тезисы *.pdf'" x-small inline>
                          <p style="margin-bottom: 0px;">{{ get_filename(reg_record.file_pdf) }}</p>
                        </v-badge>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn @click="openFile(reg_record.file_pdf)" icon>
                        <v-icon color="grey lighten-1">mdi-download</v-icon>
                      </v-btn>
                    </v-list-item-action>
                    <v-list-item-action v-if="can_delete_thesis">
                      <v-btn @click="deleteFile(reg_record.id, 'del_thesis_pdf')" icon>
                        <v-icon color="grey lighten-1">mdi-delete-forever</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item v-if="reg_record.exp_file_id > 0">
                    <v-list-item-avatar>
                      <v-icon left>mdi-file</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-badge style="margin-top: 0px !important;" color="red lighten-2" :content="'Экспертное заключение'" x-small inline>
                          <p style="margin-bottom: 0px;">{{ get_filename(reg_record.exp_file) }}</p>
                        </v-badge>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn @click="openFile(reg_record.exp_file)" icon>
                        <v-icon color="grey lighten-1">mdi-download</v-icon>
                      </v-btn>
                    </v-list-item-action>
                    <v-list-item-action>
                      <v-btn @click="deleteFile(reg_record.id, 'del_exp_file')" icon>
                        <v-icon color="grey lighten-1">mdi-delete-forever</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>

              </div>

              <v-card  class="main-container pa-3 ma-2" color="#ff8e8e" max-width="430px" style="text-align: center;" v-if="reg_record.type > 1 && reg_record.is_confirm == false && reg_record.confirm_type == 0">
                <b style="color:black; text-align: center; font-size: 16px;"> После подтверждения модератором формата вашего участия Вам будет доступна возможность скачать приглашение докладчика </b>
              </v-card>

              <div v-if="reg_record.confirm_type > 0 && selected_listen_sections.length > 0">
                  <p style="font-size: 16px;  margin-right: 30px;"><b>Планирую участвовать в качестве слушателя: </b></p>
                  <p v-for="rec in selected_listen_sections" style="font-size: 16px;  margin-left: 30px;">  {{ ' - ' }} {{ section_descr(rec) }}</p>
              </div>
            </v-card>
          </div>
        </div>

        <div class="content-personal__header d-flex justify-space-between align-start" v-if="can_reg && !wait_reg && !loading && (reg_count == 0)">
          <!-- <v-chip
            class="mr-2 ml-2"
            dark
            outlined
            label
            style="margin-bottom:20px;"
            @click="registration_dialog = true"
            color="#ff810a">
            <v-icon left>mdi-check-decagram</v-icon>
              Зарегистрироваться на форум "Курчатов ФСНЭ-2026"
          </v-chip> -->
          <v-row align="center" justify="space-around">
            <v-btn
              x-large
              color="#ff810a"
              
              dark
              @click="registration_dialog = true"
            >
              Зарегистрироваться на форум "Курчатов ФСНЭ-2026"
            </v-btn>
          </v-row>
        </div>

        <div class="content-personal__header d-flex justify-space-between align-start" v-if="can_listener_reg && !can_reg && !wait_reg && !loading && (reg_count == 0)">
          <v-row align="center" justify="space-around">
            <v-btn
              x-large
              color="#ff810a"
              
              dark
              @click="registration_listener_dialog = true"
            >
              Зарегистрироваться слушателем на форум "Курчатов ФСНЭ-2026"
            </v-btn>
          </v-row>
        </div>


        <!-- <div class="content-personal__header d-flex justify-space-between align-start" v-if="can_reg_school && !wait_reg && !loading && (reg_count == 0)">
          <v-chip
            class="mr-2 ml-2"
            dark
            outlined
            label
            style="margin-bottom:20px;"
            @click="registration_school_dialog = true"
            color="#ff810a">
            <v-icon left>mdi-check-decagram</v-icon>
              Зарегистрироваться на школу "Современные подходы к созданию детекторных материалов"
          </v-chip>
        </div> -->


        <personal-data-base/>
      </v-card>

    <v-dialog v-model="add_reg_dialog" persistent max-width="40%">
      <v-card>
        <v-card-title class="headline">Зарегистрировать дополнительное выступление
        </v-card-title>

        <v-card-text>
          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="user_type"
              :items="user_types_short"
              item-text="name"
              item-value="id"
              outlined
              chips
              required
            ></v-select>
          </div>
        </v-card-text>

        <v-card-text v-if="user_type > 1">
          <v-text-field
            v-model="dialog_comment"
            outlined
            required
            name="input-7-4"
            label="Название доклада"
          ></v-text-field>
        </v-card-text>

        <v-card-text v-if="user_type > 1">
          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="section_choice"
              :items="speaker_sections"
              item-text="name"
              item-value="id"
              outlined
              chips
              label="Выберите научное направление"
              required
            ></v-select>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="add_reg_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="add_one_reg()">{{"Зарегистрироваться"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="registration_school_dialog" persistent  width="80%" max-width="1400px">
      <v-card>
        <v-card-title class="headline">Школа "Современные подходы к созданию детекторных материалов"
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="registration_school_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="registration_school()">{{"Зарегистрироваться в качестве слушателя"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="registration_dialog" persistent  width="60%" max-width="1000px">
      <v-card>
        <v-card-title class="headline">Зарегистрироваться на мероприятие
        </v-card-title>

        <v-row>
          <v-col cols="12">
            <v-card-text>
              <b style="font-size: 16px; font-style: italic;">Выберите формат участия:</b>
            </v-card-text>
            <v-card-text class="pt-0 pb-0">
              <div class="input-container input-name modal-mul-select">
                <v-radio-group v-model="user_type">
                  <v-radio
                    v-for="n in user_types"
                    :key="n.id"
                    :label="n.name"
                    :value="n.id"
                  ></v-radio>
                </v-radio-group>

              </div>
            </v-card-text>

            <v-card-text v-if="user_type > 1" class="pt-0 pb-0">
              <b style="font-size: 14px; font-style: italic;">Выберите научное направление:</b>
              <div class="input-container input-name modal-mul-select">
                <v-radio-group v-model="section_choice">
                  <v-radio
                    v-for="n in speaker_sections"
                    :key="n.id"
                    :label="n.name"
                    :value="n.id"
                  ></v-radio>
                </v-radio-group>
              </div>
            </v-card-text>

            <v-card-text v-if="user_type > 1" class="pt-0 pb-0">
              <v-text-field
                v-model="dialog_comment"
                outlined
                required
                name="input-7-4"
                label="Название доклада"
                :error="user_type > 1 && dialog_comment.length == 0"
              ></v-text-field>
            </v-card-text>

            <v-card-text>
              <p>Экскурсия в первый день:</p>
              <v-checkbox
                style="margin-top: 0px !important; margin-left: 8px !important;"
                v-model="need_tour"
                label="хочу участвовать"
              ></v-checkbox>
            </v-card-text>

          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="registration_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="registration()">{{"Зарегистрироваться"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="registration_listener_dialog" persistent  width="60%" max-width="1000px">
      <v-card>
        <v-card-title class="headline">Зарегистрироваться на мероприятие
        </v-card-title>

        <v-row>
          <v-col cols="12">
            <v-card-text>
              <b style="font-size: 16px; font-style: italic;">Выберите формат участия:</b>
            </v-card-text>
            <v-card-text class="pt-0 pb-0">
              <div class="input-container input-name modal-mul-select">
                <v-radio-group v-model="user_type">
                  <v-radio
                    v-for="n in [{id: 1, name : 'Слушатель (без доклада)'}]"
                    :key="n.id"
                    :label="n.name"
                    :value="n.id"
                  ></v-radio>
                </v-radio-group>

              </div>
            </v-card-text>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="registration_listener_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="registration()">{{"Зарегистрироваться"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-dialog v-model="registration_dialog" persistent  width="80%" max-width="1400px">
      <v-card>
        <v-card-title class="headline">Зарегистрироваться на мероприятие
        </v-card-title>

        <v-row>
          <v-col cols="12" lg="5">
            <v-card-text>
              <b style="font-size: 16px; font-style: italic;">Выберите формат участия:</b>
            </v-card-text>
            <v-card-text class="pt-0 pb-0">
              <div class="input-container input-name modal-mul-select">
                <v-radio-group v-model="user_type">
                  <v-radio
                    v-for="n in user_types"
                    :key="n.id"
                    :label="n.name"
                    :value="n.id"
                  ></v-radio>
                </v-radio-group>

              </div>
            </v-card-text>

            <v-card-text v-if="user_type > 1" class="pt-0 pb-0">
              <b style="font-size: 14px; font-style: italic;">Выберите секцию для выступления:</b>
              <div class="input-container input-name modal-mul-select">
                <v-radio-group v-model="section_choice">
                  <v-radio
                    v-for="n in speaker_sections"
                    :key="n.id"
                    :label="n.name"
                    :value="n.id"
                  ></v-radio>
                </v-radio-group>
              </div>
            </v-card-text>

            <v-card-text v-if="user_type > 1" class="pt-0 pb-0">
              <v-text-field
                v-model="dialog_comment"
                outlined
                required
                name="input-7-4"
                label="Название доклада"
              ></v-text-field>
            </v-card-text>

            <v-card-text>
              <p>Экскурсия в первый день:</p>
              <v-checkbox
                style="margin-top: 0px !important; margin-left: 8px !important;"
                v-model="need_tour"
                label="хочу участвовать"
              ></v-checkbox>
            </v-card-text>

          </v-col>
          <v-col cols="12" lg="7">


            <v-card-text>
              <b style="font-size: 16px; font-style: italic;">На каких мероприятиях форума вы планируете присутствовать в качестве слушателя?</b>

              <v-row>
                <v-col cols="2" style="text-align: right;">
                </v-col>
                <v-col cols="10">
                  <v-checkbox v-for="section in GETTERS_SECTIONS" v-if="section.is_active"
                    :key="section.id"
                    :disabled="!section.is_public"
                    v-model="selected_listen_sections"
                    :value="section.id"
                    style="margin-top: 0px !important; margin-left: 8px !important;"
                    :label="section.is_public ? section.name : section.name + ' (по приглашениям)'"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>


          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="registration_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="registration()">{{"Зарегистрироваться"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <v-dialog v-model="confirm_reg_dialog" persistent max-width="40%">
      <v-card>
        <v-card-title class="headline">Подтвердить участие в форуме
        </v-card-title>

        <v-card-text v-if="user_registrations_list[reg_id]">
          <div v-if="user_registrations_list[reg_id].confirm_type > 1">
            <p style="margin-bottom: 0px; font-size: 16px;"><b>Предлагаемый формат участия: </b> {{ user_registrations_list[reg_id].confirm_type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом' }}</p>
            <p style="margin-bottom: 0px; font-size: 16px;"><b>Дата выступления: </b> {{ (user_registrations_list[reg_id].org_comment && user_registrations_list[reg_id].org_comment.length > 0) ? user_registrations_list[reg_id].org_comment : 'нет информации'}}</p>
          </div>
          <div v-else>
            <p style="margin-bottom: 0px; font-size: 16px;"><b>Формат участия: </b> {{ user_registrations_list[reg_id].type == 1 ? 'Слушатель' : (user_registrations_list[reg_id].type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом')}}</p>
          </div>

          <!-- <p style="margin-bottom: 0px; font-size: 16px;"><b>Формат участия: </b> {{ user_registrations_list[reg_id].type == 1 ? 'Слушатель' : (user_registrations_list[reg_id].type == 2 ? 'Участник с докладом' : 'Участник со стендовым докладом')}}</p> -->
          <p style="margin-bottom: 0px; font-size: 16px;" v-if="user_registrations_list[reg_id].type > 1"><b>Секция: </b> {{ section_descr(user_registrations_list[reg_id].section_confirm_id) }}</p>
          <p style="margin-bottom: 0px; font-size: 16px;" v-if="user_registrations_list[reg_id].type > 1"><b>Название доклада: </b> {{ user_registrations_list[reg_id].comments && user_registrations_list[reg_id].comments.length > 0 ? user_registrations_list[reg_id].comments : 'Не указано при регистрации!'}}</p>
          <!-- <p style="font-size: 14px; text-align: right; font-style: italic;"> * в случае ошибки в формате участия свяжитесь с организаторами форума</p> -->
        </v-card-text>

        <v-card-text v-if="user_registrations_list[reg_id] && user_registrations_list[reg_id].confirm_type == 3">
          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="current_confirm_type"
              :items="user_types_poster"
              item-text="name"
              item-value="id"
              outlined
              chips
              required
            ></v-select>
          </div>
        </v-card-text>

        <!-- <v-card-text>
          <div class="input-container input-name modal-mul-select">
            <v-select
              v-model="tshort_size"
              :items="sizes"
              item-text="name"
              item-value="name"
              outlined
              chips
              required
              label="пожалуйста, укажите размер футболки"
            ></v-select>
          </div>
        </v-card-text> -->

        <v-card-text>
          <p>На каких мероприятиях форума вы планируете присутствовать в качестве <b>слушателя?</b></p>
          <v-row>
            <v-col cols="2" style="text-align: right;">
            </v-col>
            <v-col cols="10">
              <v-checkbox v-for="section in GETTERS_SECTIONS" v-if="section.is_active"
                :key="section.id"
                :disabled="!section.is_public"
                v-model="selected_listen_sections"
                :value="section.id"
                style="margin-top: 0px !important; margin-left: 8px !important;"
                :label="section.is_public ? section.name : section.name + ' (по приглашениям)'"
              ></v-checkbox>
            </v-col>
          </v-row>

          <!-- <v-row>
            <v-col cols="4" style="text-align: right;">
              <p>1 день (21 октября)</p>
            </v-col>
            <v-col cols="8">
              <v-checkbox v-for="section in GETTERS_SECTIONS" v-if="section.day_numb == 1 && section.is_active"
                :key="section.id"
                :disabled="!section.is_public"
                v-model="selected_listen_sections"
                :value="section.id"
                style="margin-top: 0px !important; margin-left: 8px !important;"
                :label="section.is_public ? section.name : section.name + ' (по приглашениям)'"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" style="text-align: right;">
              <p>2 день (22 октября)</p>
            </v-col>
            <v-col cols="8">
              <v-checkbox v-for="section in GETTERS_SECTIONS" v-if="section.day_numb == 2 && section.is_active"
                :key="section.id"
                :disabled="!section.is_public"
                v-model="selected_listen_sections"
                :value="section.id"
                style="margin-top: 0px !important; margin-left: 8px !important;"
                :label="section.is_public ? section.name : section.name + ' (по приглашениям)'"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" style="text-align: right;">
              <p>3 день (23 октября)</p>
            </v-col>
            <v-col cols="8">
              <v-checkbox v-for="section in GETTERS_SECTIONS" v-if="section.day_numb == 3 && section.is_active"
                :key="section.id"
                :disabled="!section.is_public"
                v-model="selected_listen_sections"
                :value="section.id"
                style="margin-top: 0px !important; margin-left: 8px !important;"
                :label="section.is_public ? section.name : section.name + ' (по приглашениям)'"
              ></v-checkbox>
            </v-col>
          </v-row> -->
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="confirm_reg_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="confirm_reg()">{{"Подтвердить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirm_tour_dialog" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline">Вы подтверждаете желание принять участие в экскурии в НИЦ «Курчатовский институт»?
        </v-card-title>
        <v-card-text>
          Экскурсия состоится 11.11.2026. Расписание и другая информация по экскурсии будет сообщена вам дополнительно.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="confirm_tour(1)">Отказаться</v-btn>
          <v-btn color="green darken-1" text @click="confirm_tour(2)"> Подтверждаю</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancel_reg_dialog" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline">Вы уверены, что хотите отменить регистрацию на форум?
        </v-card-title>
        <v-card-text v-if="!can_reg">
          С 21.10.2026 регистрация на форум закрыта. У вас не будет возможности зарегистрироваться заново.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="cancel_reg_dialog = false">Нет</v-btn>
          <v-btn color="green darken-1" text
            @click="cancel_reg()"> Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="upload_file_dialog" persistent max-width="40%">
      <v-card>
        <v-card-title class="headline">{{ file_type == 'thesis_file' ? 'Подгрузка тезисов' : 'Подгрузка экспертного заключения' }}
        </v-card-title>

        <v-card-text v-if="file_type == 'thesis_file'">
          Загрузить файл (максимальный размер 6 мб, разрешенные форматы: doc, docx)
        </v-card-text>
        <v-card-text v-if="file_type == 'thesis_pdf'">
          Загрузить файл (максимальный размер 6 мб, разрешенные форматы: pdf)
        </v-card-text>
        <v-card-text v-if="file_type == 'exp_file'">
          Загрузить файл (максимальный размер 6 мб, разрешенные форматы: doc, docx, pdf)
        </v-card-text>
        <v-card-text>
          <v-file-input
            v-model="file"
            label="Добавить файл"
            color="#15336d"
            :success="loadedFile"
            :loading="loadedFile"
            prepend-icon="mdi-paperclip">
          </v-file-input>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="upload_file_dialog = false">отмена</v-btn>
          <v-btn color="green darken-1" text
            @click="upload_file()">{{"Загрузить"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import personalDataBase from '../components/Common/PersonalDataBase.vue'

export default {
  beforeMount() {
  },
 
  mounted() {
    if(localStorage.isLoggedIn === undefined){
      this.$router.push('/login')
      return
    }

    this.update_sections()
  },

  name: 'PersonalData',
  components: {
    personalDataBase,
  },
  data: () => ({
    // school_id: 48,   // for test database
    school_id: 36,
    listener_scholl: false,
    // currentSchoolStatus: false,

    end_reg_date: '2026-11-11',
    end_listener_reg_date: '2026-11-11',
    confirm_reg_date: '2026-10-19',
    last_end_thesis_date: '2026-11-11',
    end_thesis_date: '2026-11-11',
    start_reg_date: '2026-09-07',
    last_conf_date: '2026-11-13',
    // end_reg_school_date: '2026-10-13',
    can_upload_thesis: false,
    can_delete_thesis: false,
    can_reg: false,
    can_listener_reg: false,
    can_confirm: false,
    // can_reg_school: false,
    registration_dialog: false,
    registration_listener_dialog: false,
    registration_school_dialog: false,
    reg_id: null,
    cancel_reg_dialog: false,
    confirm_reg_dialog: false,
    confirm_tour_dialog: false,
    dialog_comment: '',
    user_registrations: null,
    user_registrations_list: [],
    upload_file_dialog: false,
    add_reg_dialog: false,
    user_type: 1,
    user_types_short: [
        {id: 2, name : 'Участник с устным докладом'},
        {id: 3, name : 'Участник со стендовым докладом'},
      ],
    user_types: [
        {id: 1, name : 'Слушатель (без доклада)'},
        {id: 2, name : 'Участник с устным докладом'},
        {id: 3, name : 'Участник со стендовым докладом'},
      ],
    current_confirm_type: 1,
    user_types_poster: [
        {id: 1, name : 'Слушатель (без доклада)'},
        {id: 3, name : 'Участник со стендовым докладом'},
      ],
    section: 0,
    loadedFile: false,
    file: null,
    checkFile: false,
    file_id: null,
    file_type: '',
    need_hotel: 0,
    hotel_start: null,
    hotel_end: null,
    day_1: false,
    day_2: false,
    day_3: false,
    day_4: false,
    need_tour: false,

    title: 'This will be the title',
    loading: false,
    model: null,
    date: new Date().toISOString().substr(0, 10),
    edit: false,
    loaded: false,
    reg_count: 0,
    can_make_sert: false,
    section_choice: 0,
    selected_listen_sections: [],
    active_sections: [],
    speaker_sections: [],
    full_sections_list: {},
    tshort_size: null,
    sizes: [
        {id: 1, name : 'S'},
        {id: 2, name : 'M'},
        {id: 3, name : 'L'},
        {id: 4, name : 'XL'},
      ],

  }),

  computed: {
    ...mapGetters([
      'GETTERS_SECTIONS',
    ]),
  },

  watch: {
    file(val) {
      if (val && typeof val === 'object') {
        this.validateFile(val) 
      }
    },

    GETTERS_SECTIONS(val) {
      this.update_sections()
     },
  },

  created() {
    this.loading = true;
  },

  methods: {
    ...mapActions([
      'logged',
      'GET_USER_SITE_REG',
      'MAKE_REGISTRATION',
      'FILE_SEND',
      'ADD_THESIS_FILE',
      'CHANGE_REGISTRATION',
      'MAKE_INVITE',
      'MAKE_SERT',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    // update_parent(item, currentSchoolStatus) {
    //   this.currentSchoolStatus = currentSchoolStatus
    // },

    scroll_to(hash){
      this.$router.push({ path: '/personal-data', hash: '#school_status' });
    },

    show_confirm_reg_dialog(){
      this.need_tour = this.user_registrations_list[this.reg_id].need_tour
      this.day_1 = this.user_registrations_list[this.reg_id].day_1
      this.day_2 = this.user_registrations_list[this.reg_id].day_2
      this.day_3 = this.user_registrations_list[this.reg_id].day_3
      this.day_4 = this.user_registrations_list[this.reg_id].day_4

      this.current_confirm_type = this.user_registrations_list[this.reg_id].confirm_type 
      this.confirm_reg_dialog = true
    },

    show_confirm_tour_dialog(id){
      this.reg_id = id
      this.confirm_tour_dialog = true
    },

    confirm_tour(val){
      console.log('confirm_tour(', val)

        let dataUpdateStatus = {
          id: this.reg_id,
          confirm_tour: val,
          type: 'confirm_tour'
        };

        this.change_reg(dataUpdateStatus)
    },

    section_descr(id){
      if(!this.full_sections_list || (id > 0 && !this.full_sections_list[id])){
        setTimeout(() => {
          return this.section_descr(id)
        }, 500);

      }
      if(id > 0 && this.full_sections_list && this.full_sections_list[id])
        return this.full_sections_list[id].name
      else
        return 'Не указано при регистрации!'
    },

    get_filename(full_path){
      var arr = full_path.split('/')
      var last = arr[(arr.length - 1)]
      return last
    },

    upload_file() {
      this.file_id = null
      if(this.checkFile) {        
        this.loadedFile = true
        const files = new FormData();
        files.append('file', this.file);

        var file_type_id = 0
        if(this.file_type == 'thesis_pdf')
          file_type_id = 3
        else if (this.file_type == 'thesis_file')
          file_type_id = 4
        else if (this.file_type == 'exp_file')
          file_type_id = 5
        files.append('type', file_type_id)



        this.FILE_SEND(files)
          .then((res) => {
            this.file = null
            this.loadedFile = false
            this.file_id = res.data.id
            this.save_thesis_file()
          })
          .catch(() => this.loadedFile = false)
      }
      
    },

    save_thesis_file(){
      let dataUpdateStatus = {
        id: this.reg_id,
        file_id: this.file_id,
        file_type: this.file_type
      }

      this.UPDATE_OVERLAY(true)

      this.ADD_THESIS_FILE(dataUpdateStatus)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {
            this.upload_file_dialog = false;
            this.reload_reg_data();
            this.$messageHelper('Успешнo', 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        })
      
    },

    openFile(fileName) {
      window.open(`https://api.kcsni-service.ru/media/${fileName}`, '_blank')
    },

    deleteFile(id,type){
      let dataUpdateStatus = {
        id: id,
        type: type
      };

      this.change_reg(dataUpdateStatus)

    },

    add_one_reg(){
      this.UPDATE_OVERLAY(true)

      var data = {
        comment: this.dialog_comment,
        type: this.user_type,
        section_choice: this.section_choice,
        one_more: true,
        selected_listen_sections: this.selected_listen_sections,
        need_tour: this.user_registrations[0].need_tour
      };

      if(this.user_type > 1){
        if(this.section_choice == 0){
          this.$messageHelper('Укажите научное направление', 'error', 3000);
          this.UPDATE_OVERLAY(false)
          return
        }
        if(this.dialog_comment.length == 0){
          this.$messageHelper('Укажите название доклада', 'error', 3000);
          this.UPDATE_OVERLAY(false)
          return
        }

      }

      this.MAKE_REGISTRATION(data)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {
            this.add_reg_dialog = false;
            this.reload_reg_data();

            this.$messageHelper('Успешная регистрация', 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        });

    },

    registration_school(){
      this.UPDATE_OVERLAY(true)

      var data = {
        comment: 'SCHOOL',
        type: 1,
        need_tour: false,
        section_choice: 36,
        one_more: false,
        selected_listen_sections: [36]
      };

      this.MAKE_REGISTRATION(data)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {
            this.registration_school_dialog = false;
            this.reload_reg_data();

            this.$messageHelper('Успешная регистрация', 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        });
    },

    registration() {
      this.UPDATE_OVERLAY(true)

      var data = {
        comment: this.dialog_comment,
        type: this.user_type,
        need_tour: this.need_tour,

        section_choice: this.section_choice,
        one_more: false,
        selected_listen_sections: this.selected_listen_sections
      };
      if(this.registration_listener_dialog){
        data['type'] = 1
      }

      if(this.user_type > 1){
        if(this.section_choice == 0){
          this.$messageHelper('Укажите научное направление', 'error', 3000);
          this.UPDATE_OVERLAY(false)
          return
        }
        if(this.dialog_comment.length == 0){
          this.$messageHelper('Укажите название доклада', 'error', 3000);
          this.UPDATE_OVERLAY(false)
          return
        }

      }

      this.MAKE_REGISTRATION(data)
        .then((res) => {
          if (!res.data.hasOwnProperty('error')) {
            this.registration_dialog = false;
            this.registration_listener_dialog = false;
            this.reload_reg_data();

            this.$messageHelper('Успешная регистрация', 'success', 3000);
          } else {
            this.$messageHelper(res.data.error, 'error', 3000);
          }
          this.UPDATE_OVERLAY(false)
        })
        .catch((e) => {
          console.log('eee', e);
          this.$messageHelper(e.message, 'error', 4000);
          this.UPDATE_OVERLAY(false)
        });

    },

    confirm_reg(){
      let dataUpdateStatus = {
          id: this.reg_id,
          is_confirm: true,
          type: 'confirm_reg',
          selected_listen_sections: this.selected_listen_sections,
          need_tour: this.need_tour,
          tshort_size: this.tshort_size,
        };
        if(this.user_registrations_list[this.reg_id].confirm_type == 3 && this.current_confirm_type == 1){
          dataUpdateStatus.cancel_poster = 1
        }
        else{
          dataUpdateStatus.cancel_poster = -1
        }
        this.change_reg(dataUpdateStatus)
    },

    cancel_reg(){
        let dataUpdateStatus = {
          id: this.reg_id,
          is_active: true,
          type: 'cancel_reg'
        };

        this.change_reg(dataUpdateStatus)
    },


    change_reg(dataUpdateStatus){
      this.UPDATE_OVERLAY(true)

      this.CHANGE_REGISTRATION(dataUpdateStatus)
      .then((res) => {
        if (!res.data.hasOwnProperty('error')) {
          this.confirm_reg_dialog = false;
          this.cancel_reg_dialog = false;
          this.confirm_tour_dialog = false;
          this.reload_reg_data();
          this.$messageHelper('Успешнo', 'success', 3000);
        } else {
          this.$messageHelper(res.data.error, 'error', 3000);
        }
        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });
    },

    make_invite(){
      this.UPDATE_OVERLAY(true)
      this.MAKE_INVITE(this.reg_id)
      .then(() => {
        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });
    },

    make_sert(){
      this.UPDATE_OVERLAY(true)

      this.MAKE_SERT(this.reg_id)
      .then((res) => {
        if (!res.hasOwnProperty('error')) {
          this.$messageHelper('Успешнo', 'success', 3000);
        } else {
          this.$messageHelper(res.error, 'error', 3000);
        }

        this.UPDATE_OVERLAY(false)
      })
      .catch((e) => {
        console.log('eee', e);
        this.$messageHelper(e.message, 'error', 4000);
        this.UPDATE_OVERLAY(false)
      });
    },

    validateFile(val) {
      const type = val.name.split('.').pop();
        
      if(val.size > 6291456){
        this.$messageHelper('Размер файла превышает 6 мб', 'error')
        this.checkFile = false
        this.file = null
      }
      else{
        if (this.file_type == 'thesis_file' && type !== 'doc' && type !== 'docx'){
          this.$messageHelper('Недопустимый формат файла', 'error')
          this.checkFile = false
          this.file = null
        }
        else if (this.file_type == 'thesis_pdf' && type !== 'pdf'){
          this.$messageHelper('Недопустимый формат файла', 'error')
          this.checkFile = false
          this.file = null
        }
        else if (this.file_type == 'exp_file' && type !== 'doc' && type !== 'docx' && type !== 'pdf'){
          this.$messageHelper('Недопустимый формат файла', 'error')
          this.checkFile = false
          this.file = null
        }
        else{
          this.checkFile = true
        }
      }

    },

    reload_reg_data(){
      this.GET_USER_SITE_REG()
      .then((res) => {
        this.reg_count = res.length;
        this.selected_listen_sections = []
        if(res.length > 0){
          this.user_registrations = res
          this.user_registrations_list = []
          var ls = []
          this.user_registrations.forEach((item) => {
            if(item.listen_sections !== null){
              ls = item.listen_sections.split(', ')
            }
            this.user_registrations_list[item.id] = item
          })
          ls.forEach((item) => {
            if(item == this.school_id){
              this.listener_scholl = true
            }
            this.selected_listen_sections.push(parseInt(item))
          })
        }
        else{
          this.user_registrations = null
          this.user_registrations_list = []
        }
      })
    },

    update_sections(){
      this.active_sections = []
      this.speaker_sections = []
      this.GETTERS_SECTIONS.forEach((item) => {
        if(item.is_active && item.is_public){
          this.active_sections.push(item)
          if(item.is_speaker)
            this.speaker_sections.push(item)
        }
        this.full_sections_list[item.id] = item
      })

      this.uploadDataUser()
    },

    async uploadDataUser() {
      try {
        this.loading =true;
        await this.logged({ token: localStorage.token });

        this.reload_reg_data()

        var curr_date = new Date().toISOString().substr(0, 10)
        this.can_reg = curr_date <= this.end_reg_date
        this.can_listener_reg = curr_date <= this.end_listener_reg_date
        
        this.can_confirm = curr_date >= this.confirm_reg_date
        
        // this.can_reg_school = curr_date <= this.end_reg_school_date

        this.can_upload_thesis = curr_date <= this.last_end_thesis_date
        this.can_delete_thesis = curr_date <= this.end_thesis_date
        
        this.wait_reg = curr_date < this.start_reg_date
        this.can_make_sert = curr_date > this.last_conf_date
        // this.can_make_sert = true
        // this.can_reg = true

        this.loading = false;
      } catch (ex) {
        console.log('ex ---> ', ex);
      }
    },
  }
}
</script>
<style lang="scss" scoped>
  .description-upload-photo{
    display: none;
    position: absolute;
    background: black;
    color: white;
    opacity: 0.65;
    top:45px;
  }
  .avatar:hover .description-upload-photo{
    display: block;
  }
  .upload{
    opacity: 0;
  }
  .description-photo{
    top:-20px;
  }
  input[type=file] {
    opacity: 0;
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
